import { gql } from "@apollo/client";

export const settingsQuery = gql`
    query GetSettings($userId: ID!) {
        settings(userId: $userId) {
            id
            name
            discreet
            favourite
            categories
        }
    }
`;
